( function( $ ) {

	let isEditMode = false;

	let PortfolioHandler = function( $scope, $ ) {

		let bf_portfolio                  = $( '.bf-portfolio' );
		let bf_portfolio_per_page         = parseInt( bf_portfolio.data( 'per-page' ) );
		let bf_portfolio_items_displayed  = parseInt( bf_portfolio.data( 'displayed' ) );
		let bf_portfolio_default_items    = bf_portfolio.data( 'filter-defaults' );
		let bf_portfolio_filter           = $( '.bf-portfolio-filter select', bf_portfolio );
		let bf_portfolio_items_container  = $( '.bf-portfolio-items', bf_portfolio );
		let bf_portfolio_items            = $( '.bf-portfolio-item', bf_portfolio_items_container );
		let bf_portfolio_items_total      = bf_portfolio_items.length;
		let bf_portfolio_load_more        = $( '.bf-portfolio-load-more', bf_portfolio );
		let bf_portfolio_load_more_button = $( '.bf-portfolio-load-more-button', bf_portfolio_load_more );

		let bf_portfolio_showcase_slick_settings = {
			dots: true,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-next"><i class="far fa-chevron-right"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="far fa-chevron-left"></i></button>',
		};

		// Sets the categories based on the Elementor widget control settings
		if ( bf_portfolio_default_items != '' ) {
			let default_array = bf_portfolio_default_items.split(' ');

			if ( default_array.length > 0 ) {
				bf_portfolio_filter.val( default_array );
				bf_portfolio_reset_displayed();
			}
		}

		function bf_portfolio_get_filtered_tag_classes() {

			let selected = bf_portfolio_filter.val();
			let tag_classes = '';

			if ( selected === '' || selected.length === 0 ) {
				return '';
			}

			if ( Array.isArray( selected ) ) {
				$.each( selected, function( index, value ) {
					if ( tag_classes !== '' ) {
						tag_classes += ', ';
					}
					tag_classes += '.bf-portfolio-item.tag-' + value;
				} );
			} else {
				tag_classes = '.bf-portfolio-item.tag-' + selected;
			}

			return tag_classes;

		}

		function bf_portfolio_reset_displayed() {
			bf_portfolio_items_displayed = bf_portfolio_per_page;

			bf_portfolio_update_displayed( bf_portfolio_items_displayed );
		}

		function bf_portfolio_load_more_items() {
			bf_portfolio_items_displayed = ( bf_portfolio_items_displayed + bf_portfolio_per_page );

			bf_portfolio_update_displayed( bf_portfolio_items_displayed );
		}

		function bf_portfolio_update_displayed( items_displayed ) {
			bf_portfolio_items_displayed = items_displayed;

			let portfolio_items, total_items;
			let tag_classes = bf_portfolio_get_filtered_tag_classes();

			bf_portfolio_items.removeClass( 'show' );
			bf_portfolio.attr( 'data-displayed', items_displayed );

			if ( tag_classes !== '' ) {
				total_items     = $( tag_classes, bf_portfolio_items_container ).length;
				portfolio_items = $( tag_classes, bf_portfolio_items_container ).slice( 0, bf_portfolio_items_displayed );
			} else {
				total_items     = bf_portfolio_items_total;
				portfolio_items = $( '.bf-portfolio-item:lt(' + bf_portfolio_items_displayed + ')', bf_portfolio_items_container );
			}

			portfolio_items.addClass( 'show' );

			$( '.bf-portfolio-item.show .bf-portfolio-item-showcase.slick-initialized' ).slick('refresh');

			$( '.bf-portfolio-item.show .bf-portfolio-item-showcase' ).not('.slick-initialized').slick( bf_portfolio_showcase_slick_settings );

			if ( portfolio_items.length >= total_items ) {
				bf_portfolio_hide_load_more();
			} else {
				bf_portfolio_show_load_more();
			}
		}

		function bf_portfolio_hide_load_more() {
			bf_portfolio_load_more.hide();
		}

		function bf_portfolio_show_load_more() {
			bf_portfolio_load_more.show();
		}

		bf_portfolio_filter.on( 'change', function() {
			bf_portfolio_reset_displayed();
		} );

		bf_portfolio_load_more_button.on( 'click', function( event ) {
			event.preventDefault();

			bf_portfolio_load_more_items();

			return false;
		} );

		let bf_portfolio_icons = bf_portfolio_filter.data( 'icons' );

		bf_portfolio_filter.selectize( {
			plugins: [ 'remove_button' ],
			placeholder: bf_portfolio_filter.data( 'placeholder' ),
			render: {
				option: function( data, escape ) {
					let markup = '<div class="bf-portfolio-select-option">';
					let icon_html = '<i class="' + bf_portfolio_icons[ data.value ] + '" role="presentation"></i>';

					markup += '<span class="option-icon">' + icon_html + '</span>';
					markup += '<span class="option-name">' + escape( data.text ) + '</span>';
					markup += '</div>';

					return markup;
				},
				item: function( data, escape ) {
					let markup = '<div class="bf-portfolio-select-item">';
					let icon_html = '<i class="' + bf_portfolio_icons[ data.value ] + '" role="presentation"></i>';

					markup += '<span class="item-icon">' + icon_html + '</span>';
					markup += '<span class="item-name">' + escape( data.text ) + '</span>';
					markup += '</div>';

					return markup;
				}
			}
		} );

		$( '.bf-portfolio-item.show .bf-portfolio-item-showcase' ).not('.slick-initialized').slick( bf_portfolio_showcase_slick_settings );

		// Hide Load More button if we initially don't even have as many items as we the amount to show per page.
		if ( bf_portfolio_items_total <= bf_portfolio_per_page ) {
			bf_portfolio_hide_load_more();
		}

	};

	$( window ).on( 'elementor/frontend/init', function() {
		if ( elementorFrontend.isEditMode() ) {
			isEditMode = true;
		}

		elementorFrontend.hooks.addAction( 'frontend/element_ready/bf-portfolio.default', PortfolioHandler );

	} );

} )( jQuery );
